import { render } from "./LbrxCurrentTicketInfoBox.vue?vue&type=template&id=20281308&scoped=true"
import script from "./LbrxCurrentTicketInfoBox.vue?vue&type=script&lang=js"
export * from "./LbrxCurrentTicketInfoBox.vue?vue&type=script&lang=js"

import "./LbrxCurrentTicketInfoBox.vue?vue&type=style&index=0&id=20281308&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20281308"]])

export default __exports__